export default __webpack_public_path__ + "static/media/dubai-outsource-city.66d2fc2d.png";